import "../assets/Common.scss";
import "../assets/fonts/font.css";
import React, { useEffect } from "react";
import PrizeGroups from "./component/PrizeGroups";
import LandingButton from "./component/LandingButton";
import "./assets/animationn.css";
import Lottie from "react-lottie";
import TitleLottie from "./assets/vending-machine-title.json";

import {
  moveToLogin,
  trackEvent,
  openWebView,
  showBottomSheet,
  getInsetTop,
  calc,
  getInsetBottom,
} from "../js/chips-common.js";
import chipsApi from "../js/chips-api";
import reloadForChecksum from "../util/ReloadChecksum";
import styled from "styled-components";
import DateFormat from "../util/DateFormat";
import CurrentMoney from "./component/CurrentMoney";

export default function VendingMachine(props) {
  const dev = props.dev;
  const domain = dev
    ? `https://api.${dev}.chips.today`
    : "https://api.chips.today";

  const [drawOpportunityCount, setDrawOpportunityCount] = React.useState(0);
  const [prizeGroups, setPrizeGroups] = React.useState([]);
  const [missions, setMissions] = React.useState([]);

  useEffect(() => {
    window.moveToLogin = moveToLogin;
    document.removeEventListener("visibilitychange", visibilityChange);
    document.addEventListener("visibilitychange", visibilityChange);

    try {
      // eslint-disable-next-line no-undef
      chipsApp.setThemeColor("#000000");

      // eslint-disable-next-line no-undef
      chipsApp.showHeader(false);

      // eslint-disable-next-line no-undef
      chipsApp.setFullscreen(true);
    } catch (e) {}

    refresh();
    reloadForChecksum();
  }, []);

  const visibilityChange = () => {
    if (!document.hidden) {
      // 페이지가 트랜지션 과정에서 active 상태로 잡히는 경우가 있어서
      // 500ms 이후 페이지가 active 상태인 경우에만 새로고침 함
      setTimeout(() => {
        if (!document.hidden) {
          refresh();
        }
      }, 500);
      refresh();
    }
  };

  function refresh() {
    const now = new DateFormat().format("yyyy.MM.dd HH:mm:ss");
    if (now >= "2024.09.01 00:00:00") {
      try {
        showBottomSheet({
          icon: "https://cdn.chips.today/logic/images/2023/09/19/1695113982488-f687da0b-f2ef-4920-b2c6-d78ef7d5e582.png",
          title: "앗, 종료된 이벤트예요.",
          body: "다음 이벤트를 기대해 주세요!",
          secondary_button_text: "확인",
          secondary_button_style: "secondary",
          secondary_button_callback: "chipsApp.close()",
        });
      } catch (e) {}
      return;
    }

    try {
      // eslint-disable-next-line no-undef
      chipsApi.request({
        method: "get",
        url: `${domain}/api/v1/benefit-events/vending_machine`,
        then: (response) => {
          const data = response.data;
          setDrawOpportunityCount(data.draw_opportunity_count);
          setPrizeGroups(data.prize_groups);
          setMissions(data.benefit_event_missions);
        },
      });
    } catch (e) {
      console.error(e);
    }
  }

  function onPrizeGroupClick(prizeGroup) {
    trackEvent("prize_group", {
      id: prizeGroup.id.toString(),
      title: prizeGroup.name,
    });
    const index =
      prizeGroups.findIndex((pg) => pg.id === prizeGroup.id) === -1
        ? 0
        : prizeGroups.findIndex((pg) => pg.id === prizeGroup.id);

    openWebView(
      `${window.location.origin}/vending-machine/draw/${prizeGroup.id}?index=${index}&dev=${dev}`,
    );
  }

  function onClickMission(mission) {
    if (mission) {
      trackEvent("mission_click", {
        id: mission.id.toString(),
        title: mission.name,
      });
    }

    try {
      if (mission?.popup) {
        // eslint-disable-next-line no-undef
        showBottomSheet({
          image: mission.popup.image_url,
          title: mission.popup.title,
          body: mission.popup.description,
          secondary_button_text: "닫기",
          primary_button_text: mission.popup.button_text,
          primary_button_style: "primary",
          primary_button_callback: `location.href="${mission.landing_url}"`,
        });
      } else if (mission?.landing_url) {
        window.location.href = mission.landing_url;
      }
    } catch (e) {}
  }

  return (
    <div
      style={{
        background: "#000",
        overflowY: "scroll",
        overflowX: "hidden",
        position: "absolute",
        width: calc(360),
        height: "100%",
      }}
    >
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
      />
      <div
        style={{
          background: "#000",
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          width: calc(360),
          zIndex: 0,
          height: "100vw",
        }}
      >
        <img
          src="https://cdn.chips.today/logic/images/2024/08/05/1722850559435-d4ff7e98-bcf0-4245-afc6-de70f8553fb4.jpg"
          style={{
            width: calc(360),
            position: "absolute",
            objectFit: "cover",
            zIndex: 0,
          }}
        />
      </div>
      <div
        style={{
          overflow: "none",
          position: "absolute",
        }}
      >
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: TitleLottie,
          }}
          isClickToPauseDisabled={true}
          style={{
            top: calc(0, getInsetTop()),
            width: calc(360),
            height: "100%",
            zIndex: 0,
          }}
        />
      </div>
      <div
        className="scrollbar-hidden"
        style={{
          position: "absolute",
          top: getInsetTop(),
        }}
      >
        <div
          style={{
            position: "fixed",
            top: getInsetTop(),
            width: calc(360),
            zIndex: 2,
          }}
        >
          <div
            className="active-small"
            style={{
              position: "absolute",
              top: 0,
              left: calc(20),
              width: calc(36),
              height: calc(60),
              display: "flex",
              justifyContent: "center",
            }}
            onClick={() => {
              try {
                // eslint-disable-next-line no-undef
                chipsApp.close();
              } catch (e) {
                window.history.back();
              }
            }}
          >
            <img
              style={{
                width: calc(36),
                height: calc(36),
              }}
              src="https://cdn.chips.today/logic/images/2024/07/26/1721968137732-c646d8e5-c97b-4a9e-8c7b-b3c446ab1404.png"
            />
          </div>
        </div>
      </div>
      <CurrentMoney currentPrizeInfo={drawOpportunityCount || 0} />
      <LandingButton dev={`${dev}`} />
      {prizeGroups && prizeGroups.length > 0 && (
        <PrizeGroups
          prizeGroups={prizeGroups}
          drawOpportunityCount={drawOpportunityCount}
          onPrizeGroupClick={onPrizeGroupClick}
        />
      )}
      <div
        className="active-only-alpha"
        style={{
          position: "fixed",
          bottom: calc(0),
          display: "flex",
          backgroundColor: "#6c00ff",
          width: calc(360),
          flexDirection: "column",
          justifyContent: "flex-end",
          zIndex: 100,
        }}
        onClick={() => {
          const mission = missions.find((mission) => mission.type === "3");
          onClickMission(mission);
        }}
      >
        <img
          src="https://cdn.chips.today/logic/images/2024/07/29/1722232421758-6234251f-ab87-4b35-868e-6801ba4c58fb.png"
          style={{
            width: calc(360),
            height: calc(70),
            marginBottom: getInsetBottom(),
          }}
        />
      </div>
    </div>
  );
}

export function showLoginBottomSheet() {
  trackEvent("login_required");

  const attributes = {
    icon: "https://cdn.chips.today/logic/barcode/zips/2024/03/18/1710756901611-0bbd476e-3c68-4a11-8500-7d2ee5f24624.png",
    title: "로그인/회원가입을 해주세요!",
    body: "로그인하고 칩스를 시작하세요.<br>지금 가입하면 신규 회원 혜택 600원까지!",
    secondary_button_text: "취소",
    primary_button_text: "시작하기",
    primary_button_callback: "moveToLogin()",
  };

  try {
    // eslint-disable-next-line no-undef
    chipsApp.showLoginBottomSheet(JSON.stringify(attributes));
  } catch (e) {}
}

export const AnimatedUnion = styled.img`
  rotate: -5deg;
  animation: rotate 2s ease-in-out infinite;
    transform-origin: 50% 50%;
    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(10deg);
        }

`;
